import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Button, Col, Row, Select, Typography } from 'antd'
import { CalendarMode } from 'antd/lib/calendar/generateCalendar'
import moment from 'moment'
import React from 'react'

import s from './calendar-header.module.less'

export interface HeaderConfigProps<T> {
  value: T
  type: CalendarMode
  onChange: (date: T) => void
  onTypeChange: (type: CalendarMode) => void
}

export const CalendarHeader: React.FC<HeaderConfigProps<moment.Moment>> = ({ value, onChange }) => {
  const month = value.month()
  const year = value.year()

  const header = (
    <div className={s.title}>
      <div className={s.date}>
        <Typography.Title level={2}>{moment(new Date(year, month, 1)).format('MMM')}</Typography.Title>
        <Typography.Title level={3}>{moment(new Date(year, month, 1)).format('YYYY')}</Typography.Title>
      </div>
      <div className={s.actions}>
        <LeftOutlined onClick={() => onChange(value.clone().subtract(1, 'month'))} />
        <Button onClick={() => onChange(moment())}>今天</Button>
        <RightOutlined onClick={() => onChange(value.clone().add(1, 'month'))} />
      </div>
    </div>
  )

  const monthSelect = (
    <Select
      size='small'
      showArrow
      value={month}
      onChange={(newMonth) => {
        onChange(value.clone().month(newMonth))
      }}
    >
      {Array.from({ length: 12 }, (_v, index) => (
        <Select.Option key={index} value={index}>
          {moment().month(index).format('MMM')}
        </Select.Option>
      ))}
    </Select>
  )

  const yearSelect = (
    <Select
      size='small'
      showArrow
      value={year}
      onChange={(newYear) => {
        onChange(value.clone().year(newYear))
      }}
    >
      {Array.from({ length: 20 }, (_v, index) => (
        <Select.Option key={index} value={new Date(year + (index - 10), 0, 1).getFullYear()}>
          {new Date(year + (index - 10), 0, 1).getFullYear()}
        </Select.Option>
      ))}
    </Select>
  )

  const content = (
    <Row className={s.content} gutter={[8, 8]}>
      <Col>{yearSelect}</Col>
      <Col>{monthSelect}</Col>
    </Row>
  )

  return (
    <div className={s.header}>
      {header}
      {content}
    </div>
  )
}
